import { enUiJson as ui } from '@onefootprint/ui';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import agents from '../locales/en/agents.json';
import analysis from '../locales/en/analysis.json';
import apiKeys from '../locales/en/api-keys.json';
import artifact from '../locales/en/artifact.json';
import askPercy from '../locales/en/ask-percy.json';
import authentication from '../locales/en/authentication.json';
import businessDetails from '../locales/en/business-details.json';
import businesses from '../locales/en/businesses.json';
import common from '../locales/en/common.json';
import connectors from '../locales/en/connectors.json';
import copilot from '../locales/en/copilot.json';
import documentViewer from '../locales/en/document-viewer.json';
import domainRestrictions from '../locales/en/domain-restrictions.json';
import entityDetails from '../locales/en/entity-details.json';
import internal from '../locales/en/internal.json';
import investigations from '../locales/en/investigations.json';
import liveAgentActivity from '../locales/en/live-agent-activity.json';
import onboarding from '../locales/en/onboarding.json';
import onboardingDataEntryViewer from '../locales/en/onboarding-data-entry-viewer.json';
import onboardingMetrics from '../locales/en/onboarding-metrics.json';
import playbookBuilder from '../locales/en/playbook-builder.json';
import playbookCustomQuestions from '../locales/en/playbook-custom-questions.json';
import playbookDetails from '../locales/en/playbook-details.json';
import playbooks from '../locales/en/playbooks.json';
import reviews from '../locales/en/reviews.json';
import roles from '../locales/en/roles.json';
import sdks from '../locales/en/sdks.json';
import securityLogs from '../locales/en/security-logs.json';
import settings from '../locales/en/settings.json';
import switchOrg from '../locales/en/switch-org.json';
import userDetails from '../locales/en/user-details.json';
import users from '../locales/en/users.json';
import vaultProxy from '../locales/en/vault-proxy.json';
import webhooks from '../locales/en/webhooks.json';

const configureReactI18next = () => {
  i18next.use(initReactI18next).init({
    resources: {
      en: {
        agents,
        analysis,
        'api-keys': apiKeys,
        artifact,
        'onboarding-data-entry-viewer': onboardingDataEntryViewer,
        'ask-percy': askPercy,
        'business-details': businessDetails,
        'document-viewer': documentViewer,
        'domain-restrictions': domainRestrictions,
        'entity-details': entityDetails,
        'live-agent-activity': liveAgentActivity,
        'onboarding-metrics': onboardingMetrics,
        'playbook-custom-questions': playbookCustomQuestions,
        'playbook-details': playbookDetails,
        'vault-proxy': vaultProxy,
        'security-logs': securityLogs,
        'switch-org': switchOrg,
        'user-details': userDetails,
        authentication,
        businesses,
        common,
        connectors,
        copilot,
        internal,
        investigations,
        onboarding,
        playbooks,
        roles,
        sdks,
        settings,
        ui,
        users,
        webhooks: webhooks,
        reviews,
        'playbook-builder': playbookBuilder,
      },
    },
    lng: 'en',
    defaultNS: 'common',
    ns: [
      'agents',
      'analysis',
      'api-keys',
      'artifact',
      'onboarding-data-entry-viewer',
      'ask-percy',
      'authentication',
      'business-details',
      'businesses',
      'common',
      'connectors',
      'copilot',
      'document-viewer',
      'domain-restrictions',
      'entity-details',
      'entity-documents',
      'investigations',
      'internal',
      'investigations',
      'live-agent-activity',
      'onboarding',
      'onboarding-metrics',
      'playbook-custom-questions',
      'playbook-details',
      'playbooks',
      'vault-proxy',
      'roles',
      'sdks',
      'security-logs',
      'settings',
      'switch-org',
      'ui',
      'user-details',
      'users',
      'webhooks',
      'reviews',
      'playbook-builder',
    ],
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
  });
  return i18next;
};

export default configureReactI18next;
